"use client";

import { startReportInputCollection } from "@/components/PaidReportCTA.collect-inputs";
import type { PaidReportCTAProps, ReportPlanId } from "@/components/PaidReportCTA.types";

export default function ReportCollectInputsButton({
  planId,
  href,
  label,
  analyticsContext,
}: {
  planId: ReportPlanId;
  href: string;
  label: string;
  analyticsContext?: PaidReportCTAProps["analyticsContext"];
}) {
  return (
    <button
      type="button"
      onClick={() => startReportInputCollection({ analyticsContext, href, planId })}
      className="inline-flex items-center justify-center px-6 py-3 rounded-lg font-semibold text-body text-white transition hover:opacity-90"
      style={{ background: "var(--ish-accent, var(--color-accent))" }}
    >
      {label}
    </button>
  );
}
